import { Component } from '@angular/core'

@Component({
    selector: 'sf-sidebar-header',
    imports: [],
    templateUrl: './sidebar-header.component.html',
    styleUrl: './sidebar-header.component.scss',
    host: {
        class: 'sidebar-header border-bottom',
    },
})
export class SidebarHeaderComponent {}
